const usercoursestatusreport = {
  namespaced: true, // ✅ Fix: This makes the module properly namespaced
  state: {
    activeTab: "tab-1", // Default tab
  },
  mutations: {
    SET_TAB(state, tab) {
      state.activeTab = tab;
    },
    RESET_TAB(state) {
      state.activeTab = "tab-1";
    },
  },
  actions: {
    changeTab({ commit }, tab) {
      commit("SET_TAB", tab);
    },
    resetTab({ commit }) {
      commit("RESET_TAB");
    },
  },
};

export default usercoursestatusreport;
